<template>
  <div class="flex flex-col flex-1 gap-4 absolute inset-0 p-4">
    <TimeSeriesData v-bind="$props" class="flex-1" @device-selected="getAlerts" />
    <div class="flex flex-row gap-4">
      <DarkCard class="flex-1">
        <div class="font-medium">Anomalies Detected</div>
        <div class="text-2xl font-bold text-red-500">{{ alerts }}</div>
        <div class="text-muted-foreground">In selected period</div>
      </DarkCard>
      <DarkCard class="flex-1">
        <div class="font-medium">Alerts Generated</div>
        <div class="text-2xl font-bold" style="color:orange">0</div>
        <div class="text-muted-foreground">Requiring attention</div>
      </DarkCard>
      <DarkCard class="flex-1">
        <div class="font-medium">User Tags</div>
        <div class="text-2xl font-bold text-blue-500">0</div>
        <div class="text-muted-foreground">Manual annotations</div>
      </DarkCard>
    </div>
  </div>
</template>

<script>
import TimeSeriesData from './TimeSeriesData.vue';
import DarkCard from './DarkCard.vue';

export default {
  name: 'TimeSeriesDataDialog',
  components: {
    TimeSeriesData,
    DarkCard
  },
  props: {
    device: String, // 用于 v-model 绑定 selectedDevice
    metrics: {
      type: Array,
      default: () => []
    },
    interval: {
      type: String,
      default: '1d'
    }
  },
  data() {
    return {
      alerts: 0,
    }
  },
  computed: {
    eventLogList() {
      return this.$store.getters['eventLog/list'] || [];
    }
  },
  methods: {
    getAlerts(selectedDevice) {
      const list = (this.eventLogList || []).filter(item => {
        return item.deviceKey === selectedDevice && item.type === 'alert';
      });
      this.alerts = list?.length ?? 0;
    }
  }
}
</script>
